import { jsx } from "react/jsx-runtime";
import React from "react";
const AnnotationContainerHolder = function(props) {
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: props.className || "annotationContainer",
      width: "100%",
      style: {
        height: props.containerHeight,
        position: "relative",
        display: "block",
        marginTop: props.marginTop + props.extraMargin,
        marginBottom: props.marginBottom
      },
      children: props.children
    }
  );
};
export default AnnotationContainerHolder;
